import { stateGo } from 'redux-ui-router';

import {
  selectHasNutritionSubscription,
  selectMemberLevel,
  selectSubscription,
} from 'logic/member';

import {
  fetchMealPlansMine,
  fetchMealPlansByVoome,
  selectPaginationByType,
  selectMealPlans,
} from 'logic/mealPlan';

export const NutritionMealPlans = {
  template: `
    <div class="nutrition-recipes">
      <ui-view>
        <div class="container pt-4">
          <div class="row">
            <div class="col-md-3">
              <meal-plan-aside
                active="$ctrl.type"
                subscription-id="$ctrl.subscriptionId"
                total-by-voome="$ctrl.byVoome.total"
                total-mine="$ctrl.mine.total"
                on-click="$ctrl.onStateGo('nutrition.mealPlans', { type: type, page: undefined })">
              </meal-plan-aside>
            </div>
            <div class="col-md-9">
              <h3 class="text-center"
                ng-show="$ctrl.isLoading">
                <spinner is-loading="$ctrl.isLoading">
                  Loading Meal Plans
                </spinner>
              </h3>
              <div class="row mb-4">
                <div ng-repeat="id in $ctrl.pagination.result track by $index"
                  class="col-md-6 col-lg-4 mb-4 pointer"
                  ng-click="$ctrl.onStateGo('nutrition.mealPlans.detail', { mealPlanId: id, type: undefined, page: undefined })">
                  <meal-plan-card
                    count="$ctrl.mealPlans[id].recipeCount"
                    date="$ctrl.mealPlans[id].updatedAt"
                    image="$ctrl.mealPlans[id].heroImage.medium"
                    title="$ctrl.mealPlans[id].title"
                    by-voome="$ctrl.type === 'byVoome'">
                  </meal-plan-card>
                </div>
                <div class="col-sm-8 mt-5 mx-auto"
                  ng-show="!$ctrl.isLoading && !$ctrl.pagination.result.length">
                  <div class="card rounded text-center py-3 px-4 mb-5">
                    <i class="fa fa-2x icon icon-recipes"></i>
                    <h4 class="text-gray">
                      You have created no meal plans.
                    </h4>
                    <p class="mb-1">
                      Create a new plan or browse the Ready-made Plans.
                    </p>
                  </div>
                </div>
                <div class="w-100 px-3">
                  <pagination-row
                    on-update-param="$ctrl.onStateGo('nutrition.mealPlans', { type: $ctrl.type, page: value })"
                    pagination="$ctrl.pagination">
                  </pagination-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ui-view>
    </div>`,

  controller($ngRedux, $anchorScroll) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        const isEdit = /edit|detail/.test(this.name);

        // Fetch voome meal plans
        if (!this.byVoome.total && !isEdit) {
          this.fetchMealPlansByVoome(this.subscriptionId, this.page);
        }

        // Fetch voome meal plans
        if (!this.mine.total && !isEdit) {
          this.fetchMealPlansMine(this.subscriptionId, this.page);
        }

        // Jump to the top of the page.
        $anchorScroll();
      },

      $onDestroy() {
        this.disconnect();
      },

      onStateGo(key, params) {
        if (this.hasAccess) {
          this.stateGo(key, params);
        }
      },

      mapState({ mealPlan, member, router }) {
        const type = router.currentParams.type || 'byVoome';
        const page = router.currentParams.page || 1;
        const { name } = router.currentState;

        const byVoome = selectPaginationByType(
          mealPlan,
          'byVoome',
          type === 'byVoome' ? page : 1
        );

        const mine = selectPaginationByType(
          mealPlan,
          'mine',
          type === 'mine' ? page : 1
        );

        return {
          byVoome,
          mine,
          page,
          type,
          name,
          mealPlans: selectMealPlans(mealPlan),
          pagination: type === 'byVoome' ? byVoome : mine,
          hasAccess: selectHasNutritionSubscription(member),
          isLoading: mealPlan.isLoading,
          level: selectMemberLevel(member),
          subscriptionId: selectSubscription(member).id,
        };
      },

      mapDispatch() {
        return {
          fetchMealPlansMine,
          fetchMealPlansByVoome,
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Nutrition/MealPlans.js